module.exports = __webpack_public_path__ + "static/img/CT_5.417c41c7.png";